import {createStore} from 'vuex'

export default createStore({
    state: {
        authing: false
    },
    mutations: {
        updateAuthing(state, status) {
            state.authing = status;
        }
    },
    actions: {},
    modules: {}
})

